import Immutable from 'immutable';

export const NO_CERTIFICATE = 'no_certificate';
export const ASQA_ACCREDITED_CERTIFICATE = 'asqa_accredited_certificate';
export const CERTIFICATE_OF_COMPLETION = 'certificate_of_completion';
export const OPENLEARNING_CERTIFICATE = 'openlearning_certificate';
export const ACCREDIBLE_CERTIFICATE = 'accredible_certificate';
export const ACCREDIBLE_CERTIFICATE_PAID = 'accredible_certificate_paid';
export const ACCREDIBLE_CREDENTIAL_SYSTEM = 'accredible_certificate';
export const OPENLEARNING_CREDENTIAL_SYSTEM = 'openlearning_certificate';
export const ACCREDIBLE_OPENCRED_PAID = 'accredible_opencred_paid';
export const ACCREDIBLE_OPENCRED = 'accredible_opencred';

export const OPEN_CRED_CERTIFICATE_SET = new Set([
  ACCREDIBLE_OPENCRED,
  ACCREDIBLE_OPENCRED_PAID,
]);

export const DIGITAL_CERTIFICATE_SET = new Set([
  ACCREDIBLE_CERTIFICATE,
  ACCREDIBLE_CERTIFICATE_PAID,
]);

export const ACCREDIBLE_CERTIFICATE_SET = new Set([
  ...OPEN_CRED_CERTIFICATE_SET,
  ...DIGITAL_CERTIFICATE_SET,
]);

export const OPENLEARNING_PDF_CERTIFICATE_SET = new Set([
  OPENLEARNING_CERTIFICATE,
  CERTIFICATE_OF_COMPLETION,
]);

export const PAID_CERTIFICATE_SET = new Set([
  ACCREDIBLE_OPENCRED_PAID,
  ACCREDIBLE_CERTIFICATE_PAID,
  ASQA_ACCREDITED_CERTIFICATE,
  CERTIFICATE_OF_COMPLETION,
]);

export const FREE_CERTIFICATE_SET = new Set([
  ACCREDIBLE_CERTIFICATE,
  ACCREDIBLE_OPENCRED,
  OPENLEARNING_CERTIFICATE,
]);

export const OPENLEARNING_CERTIFICATION_SET = new Set([
  ...ACCREDIBLE_CERTIFICATE_SET,
  ...OPENLEARNING_PDF_CERTIFICATE_SET,
]);

export const CertificationTypes = Immutable.List([
  NO_CERTIFICATE,
  OPENLEARNING_CERTIFICATE,
  ACCREDIBLE_CERTIFICATE,
  ACCREDIBLE_CERTIFICATE_PAID,
  ACCREDIBLE_OPENCRED,
  ACCREDIBLE_OPENCRED_PAID,
  CERTIFICATE_OF_COMPLETION,
  ASQA_ACCREDITED_CERTIFICATE,
]);
